export default "__VITE_ASSET__DMTK_q7R__"